import { formatDate } from "@dirootie-extensions/javascript";
import { createColumnProps } from "./_builder";
import { columnDefaultProps } from "./_shared";

export const colDate = createColumnProps(columnDefaultProps, {
  // filterObject: {
  //   defaultValue: undefined,
  //   type: FILTER_TYPES.DATE,
  // },
  formatter: (col: Date) => formatDate(col),
  sort: true,
});

export const colStartDate = createColumnProps(colDate, {
  classes: "w-20",
  dataField: "startDate",
  text: "Start date",
});

export const colEndDate = createColumnProps(colDate, {
  classes: "w-20",
  dataField: "endDate",
  text: "End date",
});
